"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// COLORS
const brand = "#8B644C"; // brown
const headerBackgroundColor = brand;
const headerTextColor = "#FFFFFF";
const appAccentColor = brand;
const mainInfoLandscape = brand;
const mainInfoPortrait = headerTextColor;
const style = "normal";
const colorAppBar = "#8B644C";
const colorOnAppBar = "#FFFFFF";
const colorPrimary = "#8B644C";
const colorPrimaryDarker = "#684b39";
const colorPrimaryLighter = "#eadfd9";
const colorOnPrimary = "#FFFFFF";
const colorSecondary = "#8B644C";
const colorOnSecondary = "#FFFFFF";
const colorTiles = ["#8B644C", "#8B644C", "#8B644C"];
exports.default = {
    brand,
    mainInfoLandscape,
    mainInfoPortrait,
    headerBackgroundColor,
    headerTextColor,
    appAccentColor,
    style,
    colorAppBar,
    colorOnAppBar,
    colorPrimary,
    colorPrimaryDarker,
    colorPrimaryLighter,
    colorOnPrimary,
    colorSecondary,
    colorOnSecondary,
    colorTiles,
};
